import React from 'react';
import cx from 'classnames';
import ValueManager from '../../../valuemanager';
import TextField from '../../../textfield';
import { eventToFieldActionUpdateRequest, getDataDescForTextField } from '../util';

const NumberEditor = React.memo(
	({label = 'Number Value',value, className, dataDescriptor, ...props}) => {
		const { label: descLabel, ...restFieldProps } = getDataDescForTextField(dataDescriptor);

		return (
			<ValueManager value={value} onChange={eventToFieldActionUpdateRequest(props)}>
				<TextField  label={descLabel || label} className={cx(className)} {...restFieldProps} />
			</ValueManager>
		)
	}
);

export default NumberEditor;